import { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import { Chevron } from "components";
import { BasicContentContainer } from "containers";
import { AppContext } from "context";

export const Overview = () => {
  const { userInfo } = useContext(AppContext);
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <BasicContentContainer
      sx={{
        backgroundImage: `linear-gradient(
          315deg,
          hsl(0deg 1% 86%) 0%,
          hsl(0deg 1% 86%) 7%,
          hsl(0deg 1% 86%) 14%,
          hsl(0deg 1% 86%) 21%,
          hsl(0deg 1% 87%) 29%,
          hsl(0deg 1% 90%) 36%,
          hsl(0deg 1% 93%) 43%,
          hsl(0deg 0% 96%) 70%,
          hsl(0deg 0% 97%) 72%,
          hsl(0deg 0% 98%) 75%,
          hsl(0deg 0% 99%) 80%,
          hsl(0deg 0% 100%) 85%,
          hsl(0deg 0% 100%) 90%,
          hsl(0deg 0% 100%) 96%,
          hsl(0deg 0% 100%) 100%
        )`,
        paddingRight: theme.spacing(5),
        paddingLeft: theme.spacing(5),
      }}
    >
      <Box
        sx={{
          paddingTop: theme.spacing(5),
          paddingBottom: theme.spacing(5),
          backgroundSize: "350px auto",
          backgroundImage: "url(/assets/images/image_overview.svg)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right bottom",
        }}
      >
        <Typography variant="h4" sx={{ marginBottom: theme.spacing(3) }}>
          Welcome {_.get(userInfo, "name")},
        </Typography>
        <Box sx={{ width: "60%" }}>
          <Typography variant="body1" sx={{ lineHeight: "2.5 !important" }}>
            To those who own TXOne products, you can register your products to
            monitor the status of your TXOne products right from here!
            <br />
            Please enter your product license key to start the registration.
          </Typography>
        </Box>
        <Button
          color="secondary"
          variant="contained"
          sx={{
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(8),
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
          }}
          endIcon={<Chevron />}
          onClick={() => {
            navigate("/product_license");
          }}
        >
          Register Now
        </Button>
      </Box>
    </BasicContentContainer>
  );
};
export default Overview;
